import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconIphoneDuo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconIphoneDuo"><Path fillRule="evenodd" clipRule="evenodd" d="M16.25 2C18.3211 2 20 3.67893 20 5.75V18.25C20 20.3211 18.3211 22 16.25 22H5.75C4.7835 22 4 21.2165 4 20.25V3.75C4 2.7835 4.7835 2 5.75 2H16.25ZM16 5C15.4477 5 15 5.44772 15 6C15 6.55228 15.4477 7 16 7C16.5523 7 17 6.55228 17 6C17 5.44772 16.5523 5 16 5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconIphoneDuo;
